(function() {
    'use strict';

    angular
        .module('inventoryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','GLOBAL_URL'];

    function stateConfig($stateProvider,GLOBAL_URL) {
        $stateProvider.state('viewAll', {
            url: '/inventory',
            data: {
                pageTitle: 'Tồn kho'
            },
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=e-stock/inventory/template/inventory',
                    controller: 'InventoryController',
                    controllerAs: 'inventoryCtr'
                }
            }
        })
    }
})();
